<svelte:options
  customElement={{
    tag: 'teo-config-panel',
    extend: extendWithStyles,
  }}
/>

<script lang="ts" module>
  import type { TeoCore } from '@/teoCore/TeoCore';
  import ConfigPanelComponent from '@/ui/components/config/ConfigPanelComponent.svelte';
  import { TeoProvider } from '@/utils/teo-context';

  import { extendWithStyles } from './web-component-utils';
</script>

<script lang="ts">
  let { teoCore }: { teoCore: TeoCore } = $props();
</script>

<TeoProvider {teoCore}>
  <ConfigPanelComponent />
</TeoProvider>
